import { Icon } from "src/components/layout/nav/icons/context-hub";
import { UseSectionHook } from "./types";
import { NavSection } from "src/components/layout/nav/nav-section";
import { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useLifecycleStudioEnabled } from "src/hooks/use-lifecycle-studio-enabled";
import { useAgentsEnabledFlag } from "src/pages/agents/hooks/use-agents-enabled-flag";
import { useIsAdStudioEnabled } from "src/pages/agents/hooks/use-is-ad-studio-enabled";
import { useResourcePermission } from "src/components/permission/use-resource-permission";

export const useContextHubSection: UseSectionHook = () => {
  const isAdStudioEnabled = useIsAdStudioEnabled();
  const isAgentsEnabled = useAgentsEnabledFlag();
  const isLifecycleStudioEnabled = useLifecycleStudioEnabled();

  return {
    title: "Context Hub",
    isEnabled: isAdStudioEnabled || isAgentsEnabled || isLifecycleStudioEnabled,
    links: [
      {
        isSub: true,
        href: "/context-hub/brands",
        label: "Brands",
      },
      {
        isSub: true,
        href: "/context-hub/knowledge",
        label: "Knowledge",
      },
      ...(isAdStudioEnabled || isLifecycleStudioEnabled
        ? [
            {
              isSub: true,
              href: "/context-hub/guardrails",
              label: "Guardrails",
            } as const,
          ]
        : []),
      ...(isAdStudioEnabled || isLifecycleStudioEnabled
        ? [
            {
              isSub: true,
              href: "/context-hub/assets",
              label: "Assets",
            } as const,
          ]
        : []),
      {
        isSub: true,
        href: "/context-hub/connected-data",
        label: "Connected data",
      },
    ],
  };
};

export const ContextHub = (props: ActiveSectionProps) => {
  const section = useContextHubSection();
  const { isPermitted: canConfigureAgents } = useResourcePermission({
    v2: { resource: "workspace", grant: "can_configure_agents" },
  });

  if (!canConfigureAgents) {
    return null;
  }

  return <NavSection icon={Icon} {...section} {...props} />;
};
